module.exports = __webpack_public_path__ + "media/images/cus_sh-35cf66183f34cb69e482ad2ed35bc189.png";